import React from 'react'

import {
  ContentWrapper,
  DropdownItemAnchorStyle,
  DropdownItemNavLinkStyle,
  DropdownItemStyle,
  IconWrapper,
  ListItem,
} from './DropdownItem.styles'
import { ItemProps, ItemAnchorProps, NavLinkProps } from './types'

const DropdownItem = function DropdownItem({
  ref,
  unmountAfterClick = true,
  icon,
  children,
  ...props
}: ItemProps & {
  ref?: React.Ref<HTMLLIElement>
}) {
  return (
    <ListItem ref={ref}>
      <DropdownItemStyle
        tabIndex={0}
        type="button" // needs to be data- so it can be picked up on the DOM
        data-unmountafterclick={unmountAfterClick}
        {...props}
      >
        {icon && <IconWrapper>{icon}</IconWrapper>}
        <ContentWrapper>{children}</ContentWrapper>
      </DropdownItemStyle>
    </ListItem>
  )
}

const DropdownItemAnchor = ({ icon, children, ...props }: ItemAnchorProps) => (
  <ListItem>
    <DropdownItemAnchorStyle {...props}>
      {icon && <IconWrapper>{icon}</IconWrapper>}
      <ContentWrapper>{children}</ContentWrapper>
    </DropdownItemAnchorStyle>
  </ListItem>
)

const DropdownItemNavLink = ({
  unmountAfterClick = true,
  icon,
  children,
  ...props
}: NavLinkProps) => {
  return (
    <ListItem>
      <DropdownItemNavLinkStyle
        data-unmountafterclick={unmountAfterClick}
        {...props}
      >
        {icon && <IconWrapper>{icon}</IconWrapper>}
        <ContentWrapper>{children}</ContentWrapper>
      </DropdownItemNavLinkStyle>
    </ListItem>
  )
}

export { DropdownItem, DropdownItemAnchor, DropdownItemNavLink, ListItem }
